<template>
	<div>
		<a-page-header style="background: #fff;" title="用户管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'用户管理'}]}}">
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input-group compact>
						<a-select style="width: 120px" v-model="searchForm.type">
							<a-select-option :value="1">ID</a-select-option>
							<a-select-option :value="2">昵称</a-select-option>
						</a-select>
						<a-input style="width: 300px" placeholder="请输入内容" v-model="searchForm.word" />
					</a-input-group>
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-page-header>

		<div class="mainBox">
			<!-- 列表 -->
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="userList" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="wxInfo" slot-scope="text,wxInfo">
						<a-avatar :src="wxInfo.headpic" />
						{{wxInfo.nickname}}
						<a-icon type="man" style="color:#597ef7 ;" v-if="wxInfo.sex == 1" />
						<a-icon style="color:#f759ab ;" type="woman" v-if="wxInfo.sex == 2" />
					</span>
					<span slot="info" slot-scope="text,info">
						<a @click="toAnchorDetail(info.rc.id)" v-if="info.rc != ''">
							<a-icon type="user" /> <strong> {{info.rc.name}}</strong></a>
					</span>
					<span slot="wx" slot-scope="wx">
						<a-avatar :src="wx.headpic" v-if="wx.headpic" />
						<span> {{wx.nickname}} </span>
						<a-icon v-if="wx.sex == 1" type="man" style="color: #40a9ff;" />
						<a-icon v-if="wx.sex == 2" type="woman" style="color:#ff4d4f" />
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toRcDetail(record.id)">详情</a>
					</span>
				</a-table>
			</div>
		</div>
	</div>
</template>

<script>
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '微信信息',
			dataIndex: 'wxInfo',
			scopedSlots: {
				customRender: 'wxInfo'
			},
		},
		{
			title: 'OPENID',
			dataIndex: 'openid',
		},
		{
			title: '加入时间',
			dataIndex: 'addtime',
		},
	];

	export default {
		data() {
			return {
				userList: [],
				columns,
				searchForm: {
					type: 2
				},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				loading: false,
			};
		},
		created() {
			this.getList()
		},
		methods: {
			toAnchorDetail(id) {
				this.$router.push('/anchor/anchorDetail?id=' + id)
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.userList = []
				this.pagination.current = pagination.current
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
					type: this.searchForm.type,
					word: this.searchForm.word,
				}
				this.$http.post('/admin/index.php/admin/User/userlist', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.userList = res.data.data
						this.pagination.total = res.data.count
					}
				})
			},
		}
	};
</script>

<style>
</style>
